// extracted by mini-css-extract-plugin
module.exports = {"Container":"style_Container__3siyF","PaymentBtns":"style_PaymentBtns__3M4X-"};